import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks"

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import LoadMore from "./LoadMore"
import Loader from "./Loader"
import SelectedFilters from "./SelectedFilters"

export default function() {
    const { response: { products }, loading } = useAppState();
    const foundProducts = products && products.total > 0;
    const [ sidebarOpen, setSidebarOpen ] = useState(false);

    const toggleSidebar = () => {
        setSidebarOpen(prevSidebarOpen => !prevSidebarOpen);
    }

    useEffect(() => {
        const searchbarEl = document.getElementById('serp-searchbar');
        if(searchbarEl && !searchbarEl.classList.contains('hidden')) {
            searchbarEl.classList.add('hidden');
        }
    }, [])

    return (
        <div class="ns-serp max-w-[1112px] mx-auto">
            {loading && !foundProducts ? (
                <Loader />
            ) : foundProducts ? (
                <>
                    <Toolbar 
                        sidebarOpen={sidebarOpen}
                        toggleSidebar={toggleSidebar}
                    />
                    <Products />
                    <LoadMore />
                </>
            ) : (
                <NoResults />
            )}
        </div>
    )
}
